var DialogMessages = /** @class */ (function () {
    function DialogMessages() {
        this.messages = {};
        //private messages: { [key: string]: DialogMessage } = {};
        this.longText = '';
        // @toDo
    }
    DialogMessages.prototype.addMessage = function (name, message) {
        this.messages[name] = message;
    };
    DialogMessages.prototype.getMessages = function () {
        return this.messages;
    };
    DialogMessages.prototype.getMessageByName = function (name) {
        //for (let current in this.messages) {}
        return typeof (this.messages[name]) !== 'undefined' ? this.messages[name] : null;
    };
    DialogMessages.prototype.getLongText = function () {
        return this.longText;
    };
    DialogMessages.prototype.setLongText = function (longText) {
        this.longText = longText;
    };
    return DialogMessages;
}());
export { DialogMessages };
export default DialogMessages;
